var _rect, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackjack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 14,
    height: 18,
    rx: 2,
    fill: "#B3BEC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C10 4 5.5 8 5.5 10.5C5.5 12.2 6.8 13.2 8 13.2C9 13.2 9.7 12.5 10 12C10.3 12.5 11 13.2 12 13.2C13.2 13.2 14.5 12.2 14.5 10.5C14.5 8 10 4 10 4Z",
    fill: "#1a1a2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 12.5L8.5 16H11.5L10.8 12.5",
    fill: "#1a1a2e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 5.5,
    y: 5,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 3.5,
    fill: "#1a1a2e"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 14.5,
    y: 17.5,
    fontFamily: "Arial",
    fontWeight: "bold",
    fontSize: 3.5,
    fill: "#1a1a2e",
    textAnchor: "end"
  }, "A")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackjack);
export default __webpack_public_path__ + "static/media/blackjack.36eb70d2893fc6509fc993844936d28a.svg";
export { ForwardRef as ReactComponent };